var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPay4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 24,
    viewBox: "0 0 78 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.405 23.6556L31.3436 0.403137H37.6414L33.7007 23.6556H27.405Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5446 0.976358C54.735 0.317325 52.8236 -0.0132503 50.8993 1.78955e-05C44.6758 1.78955e-05 40.292 3.15361 40.2548 7.67279C40.2197 11.0135 43.3846 12.8774 45.7736 13.9896C48.2254 15.1285 49.049 15.8567 49.0373 16.8769C49.0224 18.4318 47.0797 19.1418 45.2731 19.1418C42.7522 19.1418 41.4132 18.789 39.344 17.9206L38.5331 17.5506L37.6489 22.7563C39.1198 23.4054 41.8404 23.9679 44.6631 23.9968C51.284 23.9968 55.5817 20.8796 55.6306 16.0535C55.6551 13.4079 53.977 11.3953 50.3434 9.73562C48.1425 8.66196 46.7917 7.94548 46.8056 6.85686C46.8056 5.89442 47.9469 4.85712 50.4125 4.85712C52.0282 4.81998 53.6337 5.12341 55.1258 5.74791L55.6912 6.01526L56.5414 0.976358H56.5446Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.692 0.427734H67.8288C66.3208 0.427734 65.1921 0.842652 64.5343 2.35261L55.1821 23.6599H61.7956C61.7956 23.6599 62.8764 20.7951 63.1219 20.1663C63.8446 20.1663 70.2689 20.177 71.1871 20.177C71.3763 20.9908 71.9544 23.661 71.9544 23.661H77.7995L72.692 0.427734ZM64.9339 15.4129C65.4546 14.073 67.443 8.91323 67.443 8.91323C67.4069 8.97419 67.9606 7.56689 68.2784 6.69428L68.7035 8.69829L70.1616 15.4129H64.9339Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1232 0.420259L15.9593 16.2759L15.3036 13.0549C14.1558 9.33992 10.5797 5.31586 6.58057 3.30116L12.2153 23.6332L18.8787 23.6246L28.7941 0.419189L22.1232 0.420259Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2364 0.406372H0.0807688L0 0.890799C7.90153 2.81568 13.1292 7.46639 15.3036 13.0539L13.0909 2.36975C12.7105 0.897216 11.6041 0.457702 10.2364 0.406372Z",
    fill: "#F19E29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.7931,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay4);
export default __webpack_public_path__ + "static/media/pay4.7e44a0061340751a6d64cdd382387309.svg";
export { ForwardRef as ReactComponent };